import { Box, InputLabel } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';
import { fontSizes } from '../../../layouts/fontSizes';

export const SelectedItemChip = styled(Box)<{ maxWidth: string }>(
  ({ maxWidth }) => ({
    display: 'flex',
    backgroundColor: pallet.lightGrey2,
    borderRadius: '4px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    paddingInline: '6px',
    maxWidth: maxWidth || 'auto'
  })
);

export const InputLabelText = styled(InputLabel)({
  marginBottom: '6px !important',
  color: `${pallet.textLabel} !important`,
  fontSize: `${fontSizes.placeHolder} !important`
});

export const CountWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  minWidth: '41px',
  height: '20px',
  padding: '2px 6px',
  backgroundColor: pallet.primary,
  borderRadius: '6px',
  color: pallet.white,
  gap: '4px',
  marginRight: '8px'
});

export const SelectedItemContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  paddingRight: '6px',
  justifyContent: 'space-between'
});

export const SelectedItemWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
});

export const SelectAllWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
});
